import React from 'react';
import { Form, Button, Icon, Modal } from 'semantic-ui-react';
import PJModal from '../componentsHelpers/Modal';
import moment from 'moment';
import '../styles/DBAFormStyle.css';

import DBAContentCoOp from '../componentsContent/DBAContentCoOp';


class DBAFormTwo extends React.Component<any, any> {
  state = { wrongEmail: '', modalOpen: false, modalSize: 'mini', modalContent: null };

  private lis = new Array<HTMLElement>(1);

  handleShow = (i: number) => {
    this.lis[i].scrollIntoView({ block: 'end', behavior: 'smooth' });
  };

  componentDidMount() {
    console.group(this.props);
  }

  prev = (e: any) => {
    e.preventDefault();
    this.props.prevStep();
  };

  next = (e: any) => {
    e.preventDefault();

    this.setState({ modalOpen: true, modalContent: this.modalContent('Just a second...', '', true) });

    this.props.values.stp5_dbaAgreed = true;
    this.props.values.stp5_dbaAgreedTS = moment().format('DD/MM/YYYY, HH:mm:ss');

    this.props.gaEvent('event', 'SignDBA', 'Agree', 'Boots', this.props.isValid);
    this.props.nextStep(this.props);
  }

  renderScrollBtn(direction: string) {
    return (
      <div style={{ textAlign: 'center' }}>
        <Button
          onClick={(e) => {
            this.handleShow(0)
          }}
          style={{ borderBottom: "solid 3px #209639" }}
          circular
          positive
          icon
          size="big"
          data-testid="dba-button-scroll"
        >
          <Icon
            style={{ textShadow: "1px -1px #888888, 1px -3px #209639" }}
            size="big" name='arrow down' />
        </Button>
        <p style={{ fontSize: '20px', color: 'black' }}>Scroll to Accept</p>
      </div>
    );
  }

  modalContent = (title: string, msg?: string, spinner?: boolean) => {
    return (
      <React.Fragment>
        <Modal.Header style={{ textAlign: 'center' }}>{title}</Modal.Header>
        <Modal.Content style={{ textAlign: 'center' }}>
          {spinner ? <Icon loading name='spinner' size='massive' /> : null}
          <br />
          {msg ? <p>{msg}</p> : null}
        </Modal.Content>
      </React.Fragment>
    );
  };

  render() {
    let dbaContent = this.props.pdfUrl ? (
      <DBAContentCoOp pdfUrl={this.props.pdfUrl}
      />
    ) : <p style={{ textAlign: 'center' }}>Loading PDF...</p>;

    return (
      <React.Fragment>
        {this.renderScrollBtn('down')}
        <br />
        <Form.Group grouped>

          <React.Fragment>
            <div
              id="dba-message"
              className="dba-topper"
            >
              <div>
                If all of your information is correct, Leigh Day solicitors are willing to
                represent you in your equal pay claim against Co-op on a no win no fee basis.
              </div>
              <br />
              <br />
              <div>
                If you want Leigh Day to bring a claim for you then you need to click the accept
                button at the bottom of this page. This confirms you have read and agree to the client
                care and costs letter, form of authority and the Damages-Based Agreement ("DBA") below.
                You also agree that this agreement is of your own free will.
              </div>
              <br />
              <br />
              <div>
                Leigh Day can terminate the DBA at any time at no cost to you. If you terminate the DBA
                before the end of the claim or act unreasonably (please see sections 7 and 10 of the DBA),
                you may be required to pay Leigh Day your share of costs as they are at that time.
              </div>
              <br />
              <br />
              <div style={{ color: '#ff0000' }}>
                Leigh Day’s client care and costs letter, form of authority and damages-based agreement are
                contained below. The button to agree to these documents can be found below.
              </div>
            </div>

            <div
              style={{
                height: '500px',
                boxShadow:
                  '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px  rgba(0, 0, 0, 0.19)',
                overflowX: 'hidden',
                padding: '30px',
                margin: '15px auto'
              }}
            >

              {dbaContent}

            </div>
          </React.Fragment>

          <React.Fragment>
            <p>
              By clicking this button you have joined the Co-op equal pay claim. If your claim is successful,
              you agree to pay Leigh Day a fee equivalent to 25% plus VAT of any compensation received from Co-op.
            </p>
            <p>
              You have the right to cancel your agreement with Leigh Day within 14 days of entering it.
            </p>
          </React.Fragment>

          <Button.Group widths="2" style={{ margin: '10px auto' }}>
            <Button
              labelPosition="right"
              color={'green'}
              icon="right chevron"
              content={<div>Accept</div>}
              onClick={this.next}
            // data-testid="dba-button-agree"
            />
          </Button.Group>

        </Form.Group>

        <div
          style={{ lineHeight: '200px' }}
          ref={li => (this.lis[0] = li!)}
          data-testid="dba-div-scrollIntoView"
        />

        <PJModal
          size={this.state.modalSize}
          open={this.state.modalOpen}
          content={this.state.modalContent}
        />
      </React.Fragment>
    );
  }
}

export default DBAFormTwo;
